import { call, put, takeEvery, select, fork } from "redux-saga/effects"
// Crypto Redux States
import AttendanceType from "./actionTypes"

import moment from "moment"
import AttendanceAction from "./actions"
import attendanceAPI from "helpers/attendance_backend_helper"

function* fetchWorkClass({ payload }) {
  yield put(
    AttendanceAction.getWorkClassSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(attendanceAPI.getWorkClass)
    yield put(
      AttendanceAction.getWorkClassSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      AttendanceAction.getWorkClassSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchAttendanceToday() {
  yield put(
    AttendanceAction.getAttendanceTodaySuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(attendanceAPI.getToday)
    yield put(
      AttendanceAction.getAttendanceTodaySuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      AttendanceAction.getAttendanceTodaySuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchOtherWork() {
  yield put(
    AttendanceAction.getOtherWorkSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(attendanceAPI.getOtherWork)
    yield put(
      AttendanceAction.getOtherWorkSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      AttendanceAction.getOtherWorkSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchOrderList() {
  yield put(
    AttendanceAction.getAllOrderListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(attendanceAPI.getOrderList)
    yield put(
      AttendanceAction.getAllOrderListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      AttendanceAction.getAllOrderListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchMonthHistory({ payload }) {
  yield put(
    AttendanceAction.getMonthHistorySuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = payload.staffId
      ? yield call(attendanceAPI.getStaffMonthHistory, payload)
      : yield call(attendanceAPI.getMonthHistory, payload)
    yield put(
      AttendanceAction.getMonthHistorySuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      AttendanceAction.getMonthHistorySuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchAllHistoryDate({ payload }) {
  yield put(
    AttendanceAction.getAllHistoryDateSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(attendanceAPI.getDateAllHistory, payload)
    yield put(
      AttendanceAction.getAllHistoryDateSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      AttendanceAction.getAllHistoryDateSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchDetailHistoryDate({ payload, action }) {
  yield put(
    AttendanceAction.getDetailHistoryDateSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = payload.staffId
      ? yield call(attendanceAPI.getDateHistoryStaff, payload)
      : yield call(attendanceAPI.getDateHistory, payload)
    yield put(
      AttendanceAction.getDetailHistoryDateSuccess({
        loading: false,
        data,
      })
    )
    action(data)
  } catch (error) {
    console.log(error)
    yield put(
      AttendanceAction.getDetailHistoryDateSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchAssignmentList({ action }) {
  yield put(
    AttendanceAction.getAssignmentListSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(attendanceAPI.getAssignmentList)
    yield put(
      AttendanceAction.getAssignmentListSuccess({
        loading: false,
        data,
      })
    )
    action(
      data.map(i => ({
        ...i,
        checked: false,
        hour: "0",
        minute: "0",
        assignmentId: i.id,
      }))
    )
  } catch (error) {
    console.log(error)
    yield put(
      AttendanceAction.getAssignmentListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchpostClockIn({ payload, action }) {
  yield put(
    AttendanceAction.postClockInSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(attendanceAPI.postClockIn)
    yield put(
      AttendanceAction.postClockInSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      AttendanceAction.postClockInSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchpostClockOut({ payload }) {
  yield put(
    AttendanceAction.postClockOutSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let newPayload = payload
    newPayload.assignments = newPayload.assignments.filter(i => i.checked)
    newPayload.otherWorks = newPayload.otherWorks.filter(
      i => i.hour || i.minute
    )

    let { data } = yield call(attendanceAPI.postClockOut, newPayload)

    yield put(
      AttendanceAction.postClockOutSuccess({
        loading: false,
        data,
      })
    )

    // action()
  } catch (error) {
    console.log(error)
    yield put(
      AttendanceAction.postClockOutSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPutData({ payload, action }) {
  yield put(
    AttendanceAction.putDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = payload.staffId
      ? yield call(attendanceAPI.putAttendanceStaff, payload)
      : yield call(attendanceAPI.putAttendance, payload)
    yield put(
      AttendanceAction.putDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      AttendanceAction.putDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchDeleteDate({ payload, action }) {
  yield put(
    AttendanceAction.deleteDataSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = payload.staffId
      ? yield call(attendanceAPI.deleteStampDateStaff, payload)
      : yield call(attendanceAPI.deleteStampDate, payload)
    yield put(
      AttendanceAction.deleteDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      AttendanceAction.deleteDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* attendanceSaga() {
  yield takeEvery(
    AttendanceType.GET_ATTENDANCE_WORK_CLASSIFICATION,
    fetchWorkClass
  )
  yield takeEvery(
    AttendanceType.GET_ATTENDANCE_WORK_TODAY,
    fetchAttendanceToday
  )
  yield takeEvery(AttendanceType.GET_ATTENDANCE_OTHER_WORK_LIST, fetchOtherWork)
  yield takeEvery(AttendanceType.GET_ATTENDANCE_ALL_ORDER_LIST, fetchOrderList)

  yield takeEvery(AttendanceType.GET_ATTENDANCE_HISTORY, fetchMonthHistory)
  yield takeEvery(
    AttendanceType.GET_ATTENDANCE_HISTORY_BY_DATE,
    fetchAllHistoryDate
  )
  yield takeEvery(
    AttendanceType.GET_ATTENDANCE_DETAIL_HISTORY_DATE,
    fetchDetailHistoryDate
  )

  yield takeEvery(
    AttendanceType.GET_ATTENDANCE_ASSIGMENT_LIST,
    fetchAssignmentList
  )
  yield takeEvery(AttendanceType.POST_CLOCK_IN, fetchpostClockIn)
  yield takeEvery(AttendanceType.POST_CLOCK_OUT, fetchpostClockOut)
  yield takeEvery(AttendanceType.PUT_ATTENDANCE_DATE, fetchPutData)
  yield takeEvery(AttendanceType.DELETE_ATTENDANCE, fetchDeleteDate)
}

export default attendanceSaga
